
import AppData from './AppData';

export const SideDishMode = {
    MUST_SELECT     : 1,
    SELECT_UP_TO    : 2,
    SELECT_BETWEEN  : 3,
}
function MenuItem() {
    this.getCategory = this.getCategory.bind(this)
    this.getVariations = this.getVariations.bind(this)
    this.getMaxSideDish = this.getMaxSideDish.bind(this)
    this.getMinSideDish = this.getMinSideDish.bind(this)
    this.getSideDishMode = this.getSideDishMode.bind(this)
    this.isHasChoice = this.isHasChoice.bind(this)
    this.getInventoryQuantity = this.getInventoryQuantity.bind(this)
    this.checkIsOutOfStock = this.checkIsOutOfStock.bind(this)
    this.menuItemInventoryOutOfStock = this.menuItemInventoryOutOfStock.bind(this)
    this.getInventoryRemainingQuantity = this.getInventoryRemainingQuantity.bind(this)
    this.getDraftOrderItemQuantity = this.getDraftOrderItemQuantity.bind(this)
    this.getDraftOrderChoiceQuantity = this.getDraftOrderChoiceQuantity.bind(this)
    this.isNegativeStock = this.isNegativeStock.bind(this)
    this.isInfiniteInventory = this.isInfiniteInventory.bind(this)
    this.isInfiniteMenuItem = this.isInfiniteMenuItem.bind(this)
    this.calculateChoiceTotalQuantity = this.calculateChoiceTotalQuantity.bind(this)
    this.isInfiniteMenuItem = this.isInfiniteMenuItem.bind(this)
    this.getImageUrl = this.getImageUrl.bind(this)
}

MenuItem.prototype.getImageUrl = function() {
    return (window.resource_use_storage_url && this.storage_url) || this.image_path
}

MenuItem.prototype.getCategory = function() {
    return AppData.data.state.categories.find(category => category.id == this.category_id)
}
MenuItem.prototype.getVariations = function() {
    let variationGroupId = this.variation_group_id
    if (variationGroupId) {
        let choices = AppData.data.state.variation.choices.filter((item) => variationGroupId && item.variation_group_id == variationGroupId)
        let addons = AppData.data.state.variation.addons.filter((item) => variationGroupId && item.variation_group_id == variationGroupId)
        let options = AppData.data.state.variation.options.filter((item) => variationGroupId && item.variation_group_id == variationGroupId)
        let sideDishes = AppData.data.state.variation.sideDishes.filter((item) => variationGroupId && item.variation_group_id == variationGroupId)
        if (sideDishes.length <= 0) {
            sideDishes = AppData.data.state.variation.sideDishes.filter((item) => item.item_id == this.id)
        }
        return { choices, addons, options, sideDishes }
    }
    else {
        let choices = AppData.data.state.variation.choices.filter((item) => item.item_id == this.id)
        let addons = AppData.data.state.variation.addons.filter((item) => item.item_id == this.id)
        let options = AppData.data.state.variation.options.filter((item) => item.item_id == this.id)
        let sideDishes = AppData.data.state.variation.sideDishes.filter((item) => item.item_id == this.id)
        return { choices, addons, options, sideDishes }
    }
}

MenuItem.prototype.getMaxSideDish = function(group) {
    let { side_dish_detail = {} } = this
    if (side_dish_detail.length) {
        let sdd = side_dish_detail.find(sd => sd.group == group)
        if (sdd) {
            return parseInt(sdd.max_side_dish)
        }
    }
    return 0
}
MenuItem.prototype.getMinSideDish = function(group) {
    let { side_dish_detail = {} } = this
    if (side_dish_detail.length) {
        let sdd = side_dish_detail.find(sd => sd.group == group)
        if (sdd) {
            return parseInt(sdd.min_side_dish)
        }
    }
    return 0
}
MenuItem.prototype.getSideDishMode = function(group) {
    let { side_dish_detail = {} } = this
    if (side_dish_detail.length) {
        let sdd = side_dish_detail.find(sd => sd.group == group)
        if (sdd) {
            return sdd.side_dish_mode && parseInt(sdd.side_dish_mode) || SideDishMode.MUST_SELECT
        }
    }
    return 0
}
MenuItem.prototype.isHasChoice = function() {
    return (AppData.data.state.variation?.choices || []).find(c => c.item_id == this.id) != null
}
MenuItem.prototype.getInventoryQuantity = function() {
    return parseInt(this.inventory_quantity || 0)
}
MenuItem.prototype.checkIsOutOfStock = function() {
    const isInventoryModuleEnabled = AppData.data.isInventoryModuleEnabled()
    // Simple check of isOutOfStock, based on DB flag
    if (this.is_out_of_stock || this.is_out_of_stock_until) {
        return true
    }
    if (isInventoryModuleEnabled) {
        return this.menuItemInventoryOutOfStock()
    }
}
MenuItem.prototype.menuItemInventoryOutOfStock = function() {
    if (this.isHasChoice()) {
        return !this.isInfiniteInventory() && this.getInventoryRemainingQuantity() <= 0
    }
    else {
        return !this.isInfiniteMenuItem() && this.getInventoryRemainingQuantity() <= 0
    }
}
MenuItem.prototype.getInventoryRemainingQuantity = function() {
    let calculatedQuantity = 0
    let draftOrderItemQuantity = this.getDraftOrderItemQuantity()

    // Ignoring choice, just a simple MenuItemQuantity - draftItemQuantity
    let menuItemQuantity = this.getInventoryQuantity() - draftOrderItemQuantity

    if (this.isHasChoice()) {
        // Get remaining of all Choice item
        const { isInfinite, inventoryChoiceQuantity, } = this.calculateChoiceTotalQuantity()
        const infiniteMenuItem = this.isInfiniteMenuItem()

        // Check if we are limited by MenuItem, or by Choice item
        // A.   Infinite MenuItem,  Infinite ChoiceItem
        if (infiniteMenuItem && isInfinite) {
            // Caller should check isInfinite() before call this, so caller should handle the 'calculatedQuantity = 0' properly as "infinite"
        }

        // B.   Limited MenuItem,   Infinite ChoiceItem
        else if (!infiniteMenuItem && isInfinite) {
            calculatedQuantity = menuItemQuantity
        }

        // C.   Infinite MenuItem,   Limited ChoiceItem
        else if (infiniteMenuItem && !isInfinite) {
            calculatedQuantity = inventoryChoiceQuantity
        }

        // D.   Limited MenuItem,   Limited ChoiceItem
        else if (!infiniteMenuItem && !isInfinite) {
            // Both MenuItem and ChoiceItem are limited, return the smaller number
            calculatedQuantity = menuItemQuantity < inventoryChoiceQuantity ? menuItemQuantity : inventoryChoiceQuantity
        }
        else {
            // Impossible case
        }
    }
    else {
        // No choice to choose from, so a simple menu item quantity is good enough
        calculatedQuantity = menuItemQuantity // this.getInventoryQuantity() - draftOrderItemQuantity
    }
    return calculatedQuantity
}

function getOrders() {
    let orders = []
    if (window.appType === 'user') {
        orders = AppData.data.state.orders
    }
    else {
        orders = AppData.data.state.adminOrders
    }
    return orders || []
}
MenuItem.prototype.getDraftOrderItemQuantity = function() {
    let draftOrderItemQuantity = 0
    getOrders().filter(order => order.menu_item_id == this.id && order.order_status == "draft").forEach(order => {
        draftOrderItemQuantity += order.quantity
    })
    return draftOrderItemQuantity
}

MenuItem.prototype.getDraftOrderChoiceQuantity = function(choiceId) {
    let draftOrderItemQuantity = 0
    getOrders().filter(order => order.menu_item_id == this.id && order.order_status == "draft").forEach(order => {
        if (order.option_ids && order.option_ids[0] == choiceId) {
            draftOrderItemQuantity += order.quantity
        }
    })
    return draftOrderItemQuantity
}

MenuItem.prototype.isNegativeStock = function() {
    if (!this.isHasChoice()) {
        return !this.isInfiniteMenuItem() && this.getInventoryRemainingQuantity() < 0
    }
    else {
        // Handle item that has choice
        const finalStockAfterDraftOrder = this.getInventoryRemainingQuantity()
        return !this.isInfiniteInventory() && finalStockAfterDraftOrder < 0
    }
}
/**
 * Check if this item has infinite quantity in terms of MenuItem and combination of all the ChoiceItem
 * @returns {Boolean}
 */
MenuItem.prototype.isInfiniteInventory = function() {
    const { isInfinite } = this.calculateChoiceTotalQuantity()
    // Infinite MenuItem and Infinite ChoiceItem
    return isInfinite && this.isInfiniteMenuItem()
}
/**
 * Check if this item has infinite quantity of MenuItem
 * @returns {Boolean}
 */
MenuItem.prototype.isInfiniteMenuItem = function() {
    return (!this.track_inventory || typeof this.inventory_quantity === 'undefined')
}
MenuItem.prototype.calculateChoiceTotalQuantity = function() {
    const { choices } = this.getVariations()
    let isInfinite = false
    let inventoryChoiceQuantity = 0
    if (this.isHasChoice() && choices.length > 0) {
        let totalChoiceQuantity = 0
        for (let i = 0; i < choices.length; i++) {
            const choice = choices[i]
            if ((!choice.track_inventory || typeof choice.inventory_quantity === 'undefined') && choice.in_stock) {
                // One of the choice has infinite quantity
                isInfinite = true
                break
            }
            else {
                if (!choice.in_stock) {
                    // Admin specifically set this Choice as no stock, skip inventory count
                }
                else {
                    totalChoiceQuantity += (choice.inventory_quantity || 0)
                }
                let draftOrderQuantity = this.getDraftOrderChoiceQuantity(choice.id)
                if (draftOrderQuantity != 0) {
                    totalChoiceQuantity -= draftOrderQuantity
                }
            }
        }
        if (!isInfinite) {
            inventoryChoiceQuantity = totalChoiceQuantity
        }
    }
    return { isInfinite, inventoryChoiceQuantity, }
}
export default MenuItem;